import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgT1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 60 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 26)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M30.747-1a2 2 0 011.418.59h0l8.363 10.052 14.07 4.52a1.997 1.997 0 011.395 1.74h0L56 22a1.997 1.997 0 01-1.833 1.993h0l-1.317.004a7.49 7.49 0 01-2.256 4.008A7.474 7.474 0 0145.5 30a7.474 7.474 0 01-5.094-1.995A7.49 7.49 0 0138.15 24h0-19.3a7.49 7.49 0 01-2.256 4.005A7.474 7.474 0 0111.5 30a7.474 7.474 0 01-5.094-1.995A7.49 7.49 0 014.15 24h0H1a1.997 1.997 0 01-1.993-1.835h0L-1 9.208 4.806-.078a2 2 0 011.506-.914h0z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0D0E10",
				d: "M12 8h28v2H12z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0D0E10",
				d: "M12 0h2v10h-2zM21 0h2v10h-2z"
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 11.5,
				cy: 22.5,
				r: 2.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 45.5,
				cy: 22.5,
				r: 2.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				x: 56,
				y: 16,
				width: 2,
				height: 4,
				rx: 1
			})
		]
	})
});
export default SvgT1;
